import { render, staticRenderFns } from "./TeachersView.vue?vue&type=template&id=76a42b3b"
import script from "./TeachersView.vue?vue&type=script&lang=js"
export * from "./TeachersView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports